export default __webpack_public_path__ + "static/media/ki.0ea9841e.svg";